import React from "react";
import { FiCheck, FiLinkedin } from "react-icons/fi";

const AboutOne = () => {
  return (
    <div className="rwt-about-area rn-section-gap rn-color">
      <div className="container">
        <div className="row row--30 align-items-center">
          <div className="col-lg-5">
            <div className="thumbnail">
              <img
                className="w-100"
                src="./dare/dan-04.png"
                alt="About Images"
                loading="lazy"
              />
            </div>
          </div>

          <div className="col-lg-7 mt_md--40 mt_sm--40">
            <div className="content">
              <div className="section-title">
                <h1 className="title">
                  <span className="theme-gradient">
                    ¡Hola a todos! Soy Dan Panini
                  </span>
                </h1>
                <p className="p3">
                  Creador de la 1er consultora de
                  RR.HH especializada en gastronomía dirigida por chefs y
                  gerentes de restaurante.<br/><br/> He tenido el privilegio de dejar mi
                  marca en algunos de los nombres más icónicos de la gastronomía
                  Argentina, como Hard Rock Cafe, Hyatt, Sushi Club, Starbucks,
                  Le Pain Quotidien, Kansas, Le Ble, y Cerveza Hormiga Negra,
                  entre otros.<br/> <br/>Ocupé roles destacados como Gerente General,
                  Gerente de Operaciones, Chef Ejecutivo y Mentor Ejecutivo
                  (trabajando con dueños y gerentes). También colaboré como
                  profesor en el Instituto Gato Dumas en las carreras de
                  Gerenciamiento Gastronómico y Cocinero Profesional.
                  
                </p>
                <br />
                <div className="text-center">
                <a class="linkedin-button" href="https://www.linkedin.com/in/danpanini/" target="_blank">
                <i><FiLinkedin /></i>
                Conéctate conmigo
    </a>
    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutOne;
